import React, { Suspense, useEffect, useMemo } from 'react';
import { Spin } from 'antd';
import { Outlet } from 'react-router-dom';

import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import { CommonTableProps } from '../../../../crm/interfaces/common.interface';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import {
    ShopDetailsFiltersProps,
    ShopDetailsProps,
} from '../service/shop-details.interface';
import { getColumns } from '../utils/getColumns';
import { useLazyReadShopsAdminQuery } from '../service/adminShopDetailsApi';
import UniversalTable from '../../../components/UniversalTable';

export const ShopDetailsContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        ShopDetailsFiltersProps,
        ShopDetailsProps
    >(useLazyReadShopsAdminQuery, null);

    const tableProps = useMemo<
        CommonTableProps<ShopDetailsProps, ShopDetailsFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
            getColumns,
            entityName: 'Всего',
            rowKey: item => item.shop_id,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            get({ filters: filters }, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get]);

    return (
        <Suspense fallback={<Spin />}>
            <UniversalTable {...tableProps} />
        </Suspense>
    );
};
